import { InputValidationRule } from 'vuetify';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const noop = (text: string) => '';

export const emptyCheck = (v: string) =>
  typeof v === 'string' && v.trim().length > 0;

export const min8LenCheck = (v: string) => emptyCheck(v) && v.length >= 8;

export const nonNumOnlyCheck = (v: string) =>
  min8LenCheck(v) && /^\d+$/.test(v) === false;

export const positiveIntegersOnlyCheck = (v: string) =>
  emptyCheck(v) && /^[+]?\d+$/.test(v) === true;

export const integersOnlyCheck = (v: string) =>
  emptyCheck(v) && /^[-+]?\d+$/.test(v) === true;

export const positiveNumbersOnlyCheck = (v: string) =>
  emptyCheck(v) && /^[+]?\d+(\.\d+)?$/.test(v) === true;

export const numbersOnlyCheck = (v: string) =>
  emptyCheck(v) && /^[-+]?\d+(\.\d+)?$/.test(v) === true;

export const emailCheck = (v: string) =>
  emptyCheck(v) && /\S+@\S+\.\S+/.test(v);

export const emailRules = (translator = noop): InputValidationRule[] => {
  const req = translator('email_required');
  const invalid = translator('email_invalid');
  return [
    v => emptyCheck(v) || req || 'E-mail address is required',
    v => emailCheck(v) || invalid || 'E-mail address must be valid',
  ];
};

export const passwordRules = (translator = noop): InputValidationRule[] => {
  const req = translator('password_required');
  const short = translator('password_too_short');
  const num = translator('password_not_numeric');
  return [
    v => emptyCheck(v) || req || 'Password is required',
    v => min8LenCheck(v) || short || 'Password must be at least 8 chars',
    v => nonNumOnlyCheck(v) || num || 'Password must include non-numeric chars',
  ];
};
